// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"24d091be","442":"26a8aa84","781":"16b9f101"}[chunkId] + ".js";
};